import { z } from 'zod';
import { TimestampSchema, UuidSchema } from './common';

export const TenantMemberRoleSchema = z.enum(['owner', 'admin', 'operator', 'viewer']);
export type TenantMemberRole = z.infer<typeof TenantMemberRoleSchema>;

export const TenantMemberSchema = z.object({
  userId: UuidSchema,
  email: z.string().email(),
  name: z.string().nullable(),
  role: TenantMemberRoleSchema,
  joinedAt: TimestampSchema,
});
export type TenantMember = z.infer<typeof TenantMemberSchema>;

export const TenantMembersListResponseSchema = z.object({
  members: z.array(TenantMemberSchema),
});
export type TenantMembersListResponse = z.infer<typeof TenantMembersListResponseSchema>;

export const AddTenantMemberInputSchema = z.object({
  email: z.string().email(),
  role: TenantMemberRoleSchema.exclude(['owner']),
});
export type AddTenantMemberInput = z.infer<typeof AddTenantMemberInputSchema>;

export const UpdateTenantMemberRoleInputSchema = z.object({
  role: TenantMemberRoleSchema.exclude(['owner']),
});
export type UpdateTenantMemberRoleInput = z.infer<typeof UpdateTenantMemberRoleInputSchema>;
